import { BPagination } from 'bootstrap-vue';
import CardProduto from './vue-components/CardProduto';
import messenger from './vue-components/messenger';
import novochat from './vue-components/messenger-novochat';
import filters from './vue-filter';
import {vmax, vmin, vdefault} from './vue-directives';
Vue.filter('currency', filters.currency);
Vue.component('card-produto', CardProduto);
Vue.component('b-pagination', BPagination);
Vue.component('messenger', messenger);
Vue.component('novochat', novochat);

Vue.directive('min', vmin);
Vue.directive('max', vmax);
Vue.directive('default', vdefault);


// WEBPACK FOOTER //
// ./resources/assets/js/loja/app.js